<div class="card grupo-email-container">
    <p-toolbar styleClass="mb-4 grupo-email-toolbar">
        <ng-template pTemplate="left">
            <button
                pButton
                pRipple
                label="Novo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                (click)="openNew()"
            ></button>
        </ng-template>
    </p-toolbar>
 
    <div class="grupo-email-table-wrapper" #tableWrapper>
        <p-table
            #dt
            [value]="data"
            [rows]="20"
            styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true"
            [rowHover]="true"
            dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
            [showCurrentPageReport]="true"
            [globalFilterFields]="['id', 'descricao', 'tipo', 'cliente.nome']"
            [scrollable]="true"
            [scrollHeight]="scrollHeight"
        >
        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Grupos de Email</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input
                        pInputText
                        type="text"
                        (input)="
                            dt.filterGlobal($event.target.value, 'contains')
                        "
                        placeholder="Pesquisar..."
                    />
                </span>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th style="width: 6%">Código</th>
                <th style="width: 18%">Descrição</th>
                <th style="width: 8%">Tipo</th>
                <th style="width: 14%">Cliente</th>
                <th style="width: 8%">Status</th>
                <th style="width: 10%">Qtd. Emails</th>
                <th style="width: 10%">Qtd. Estações</th>
                <th class="col-acoes" style="width: 12%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-grupo>
            <tr>
                <td>
                    <span class="p-column-title negrito">Código: </span
                    >{{ grupo.id }}
                </td>
                <td>
                    <span class="p-column-title negrito">Descrição: </span
                    >{{ grupo.descricao }}
                </td>
                <td>
                    <span class="p-column-title negrito">Tipo: </span
                    >{{ grupo.tipo }}
                </td>
                <td>
                    <span class="p-column-title negrito">Cliente: </span
                    >{{ grupo.cliente?.nome }}
                </td>
                <td>
                    <span class="p-column-title negrito">Status: </span>
                    {{ grupo.ativo ? "Ativo" : "Inativo" }}
                </td>
                <td>
                    <span class="p-column-title negrito"
                        >Quantidade de Emails: </span
                    >{{ grupo.emails?.length || 0 }}
                </td>
                <td>
                    <span class="p-column-title negrito"
                        >Quantidade de Estações: </span
                    >{{ grupo.estacoes?.length || 0 }}
                </td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button
                        pButton
                        pRipple
                        icon="pi pi-pencil"
                        class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar"
                        (click)="edit(grupo)"
                    ></button>
                    <button
                        pButton
                        pRipple
                        icon="pi pi-trash"
                        class="p-button-rounded p-button-danger"
                        pTooltip="Excluir grupo de email"
                        (click)="confirmarExclusao(grupo)"
                    ></button>
                </td>
            </tr>
        </ng-template>
        </p-table>
    </div>
</div>

<p-dialog
    header="Grupo de Email"
    [(visible)]="displayModal"
    [modal]="true"
    [breakpoints]="{ '960px': '75vw' }"
    [style]="{ width: '70vw' }"
    [baseZIndex]="10000"
    [draggable]="false"
    [resizable]="false"
>
    <div [ngStyle]="{ margin: '7px' }">
        <form [formGroup]="form" class="p-fluid grid">
            <div class="field col-12 md:col-2">
                <div class="field-checkbox">
                    <p-checkbox
                        inputId="ativo"
                        formControlName="ativo"
                        [binary]="true"
                    ></p-checkbox>
                    <label for="ativo" class="p-checkbox-label">Ativo</label>
                </div>
            </div>

            <div class="field col-12 md:col-3" *ngIf="isUsuarioInterno || form.get('id')?.value">
                <div class="field-checkbox">
                    <p-checkbox
                        inputId="grupo_interno"
                        formControlName="grupo_interno"
                        [binary]="true"
                        (onChange)="onTipoGrupoChange()"
                    ></p-checkbox>
                    <label for="grupo_interno" class="p-checkbox-label"
                        >Grupo Interno</label
                    >
                </div>
            </div>

            <div class="field col-12">
                <p-floatlabel>
                    <input
                        type="text"
                        id="descricao"
                        pInputText
                        formControlName="descricao"
                        maxlength="80"
                    />
                    <label for="descricao">Descrição *</label>
                </p-floatlabel>
                <small
                    *ngIf="
                        form.get('descricao').invalid &&
                        form.get('descricao').touched
                    "
                    class="p-error"
                >
                    Descrição é obrigatória.
                </small>
            </div>

            <div
                *ngIf="!form.get('grupo_interno').value"
                class="field col-12"
            >
                <p-floatlabel>
                    <p-dropdown
                        inputId="pessoa_cliente_id"
                        appendTo="body"
                        [filter]="true"
                        [options]="dropDownClientes"
                        formControlName="pessoa_cliente_id"
                        optionLabel="label"
                        optionValue="value"
                    >
                    </p-dropdown>
                    <label for="pessoa_cliente_id">Cliente *</label>
                </p-floatlabel>
            </div>

            <div
                *ngIf="!form.get('grupo_interno').value"
                class="field col-12"
            >
                <label for="estacoes">Estações *</label>
                <p-multiSelect
                    [options]="dropDownEstacoes"
                    [filter]="true"
                    filterLocale="pt-BR"
                    formControlName="estacoes"
                    appendTo="body"
                    optionLabel="label"
                    optionValue="value"
                >
                </p-multiSelect>
                <small
                    *ngIf="
                        form.get('estacoes').invalid &&
                        form.get('estacoes').touched
                    "
                    class="p-error"
                >
                    Pelo menos uma estação deve ser selecionada.
                </small>
            </div>

            <div
                *ngIf="!form.get('grupo_interno').value"
                class="field col-12"
            >
                <label class="mb-2">Dias da semana</label>
                <div class="grid align-items-center">
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_dom"
                                formControlName="diasemana_dom"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_dom">Dom</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_seg"
                                formControlName="diasemana_seg"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_seg">Seg</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_ter"
                                formControlName="diasemana_ter"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_ter">Ter</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_qua"
                                formControlName="diasemana_qua"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_qua">Qua</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_qui"
                                formControlName="diasemana_qui"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_qui">Qui</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_sex"
                                formControlName="diasemana_sex"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_sex">Sex</label>
                        </div>
                    </div>
                    <div class="col">
                        <div class="field-checkbox">
                            <p-checkbox
                                inputId="diasemana_sab"
                                formControlName="diasemana_sab"
                                [binary]="true"
                            ></p-checkbox>
                            <label for="diasemana_sab">Sáb</label>
                        </div>
                    </div>
                </div>
            </div>

            <div
                *ngIf="!form.get('grupo_interno').value"
                class="field col-12 md:col-4"
            >
                <p-floatlabel>
                    <input
                        type="time"
                        id="horario"
                        pInputText
                        formControlName="horario"
                    />
                    <label for="horario">Horário</label>
                </p-floatlabel>
            </div>

            <div class="field col-12">
                <label>Emails *</label>
                <div class="p-inputgroup">
                    <input
                        type="email"
                        pInputText
                        placeholder="Digite o email"
                        [(ngModel)]="novoEmail"
                        [ngModelOptions]="{ standalone: true }"
                        (keyup.enter)="adicionarEmail()"
                    />
                    <button
                        pButton
                        type="button"
                        icon="pi pi-plus"
                        class="p-button-success"
                        (click)="adicionarEmail()"
                        [disabled]="!isEmailValido(novoEmail)"
                    ></button>
                </div>
                <small
                    *ngIf="!isEmailValido(novoEmail) && novoEmail"
                    class="p-error"
                >
                    Email inválido.
                </small>
            </div>

            <div class="field col-12">
                <label>Emails Adicionados *</label>
                <div class="emails-list">
                    <div
                        *ngFor="let email of emailsAdicionados"
                        class="email-item flex align-items-center justify-content-between p-p-2 mb-2"
                        [class]="
                            email.ativo ? 'active-email' : 'inactive-email'
                        "
                    >
                        <div class="flex align-items-center">
                            <p-checkbox
                                [(ngModel)]="email.ativo"
                                [ngModelOptions]="{ standalone: true }"
                                (onChange)="atualizarEmailsNoForm()"
                                [binary]="true"
                            ></p-checkbox>
                            <span class="ml-2">{{ email.email }}</span>
                        </div>
                        <button
                            pButton
                            type="button"
                            icon="pi pi-trash"
                            class="p-button-danger p-button-text p-button-sm"
                            (click)="removerEmail(email)"
                        ></button>
                    </div>

                    <div
                        *ngIf="emailsAdicionados.length === 0"
                        class="p-p-2 p-text-center text-muted"
                    >
                        Nenhum email adicionado
                    </div>
                </div>
                <small
                    *ngIf="
                        emailsAdicionados.length === 0 &&
                        form.get('emails').touched
                    "
                    class="p-error"
                >
                    Pelo menos um email deve ser adicionado.
                </small>
            </div>
        </form>
    </div>

    <ng-template pTemplate="footer">
        <button
            pButton
            pRipple
            type="button"
            icon="pi pi-arrow-left"
            (click)="displayModal = false"
            label="Voltar"
            class="p-button-raised p-button-warning mr-2"
        ></button>
        <button
            *ngIf="loading == false"
            [disabled]="form.invalid"
            pButton
            pRipple
            type="button"
            icon="pi pi-check"
            (click)="save()"
            label="Salvar"
            class="p-button-raised p-button-success"
        ></button>
        <p-progressSpinner
            *ngIf="loading"
            [style]="{ width: '50px', height: '50px' }"
            styleClass="custom-spinner"
            strokeWidth="8"
            fill="#EEEEEE"
            animationDuration=".5s"
        ></p-progressSpinner>
    </ng-template>
</p-dialog>
